import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Button,
  Typography,
  Container
} from '@mui/material';

interface InvitationErrorScreenProps {
  errorMessage: string;
  onGoToRegister: () => void;
  onGoToLogin: () => void;
}

export const InvitationErrorScreen: React.FC<InvitationErrorScreenProps> = ({
  errorMessage,
  onGoToRegister,
  onGoToLogin
}) => {
  return (
    <Container component="main" maxWidth="sm">
      <Box sx={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 3
      }}>
        <Card sx={{
          width: '100%',
          textAlign: 'center',
          p: 4
        }}>
          <CardContent>
            <Typography variant="h4" gutterBottom sx={{ color: 'error.main', mb: 2 }}>
              Código de Invitación Inválido
            </Typography>
            <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
              {errorMessage}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
              <Button
                variant="outlined"
                onClick={onGoToRegister}
              >
                Registro Normal
              </Button>
              <Button
                variant="contained"
                onClick={onGoToLogin}
              >
                Iniciar Sesión
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};
